<template>
  <section
    class="component-de94ab88"
    resmed-component-name="explore_4col-line_text_link"
    v-bind:style="{ background: acf.layout['background'] }"
  >
    <div
      class="component"
      v-bind:class="{
        'is-cta-style-pill': acf.layout['cta-style'] === 'pill',
        'content-alignment-center':
          acf.layout['content-alignment'] === 'center',
      }"
    >
      <div class="container">
        <div class="row justify-content-center">
          <div class="col">
            <eyebrow-icon
              v-if="acf.eyebrowicon"
              v-bind:eyebrowicon="acf.eyebrowicon"
              v-bind:align="
                acf.layout['content-alignment'] === 'center' ? 'center' : ''
              "
            ></eyebrow-icon>
            <h2>{{ acf.headline }}</h2>
          </div>
        </div>

        <div class="row">
          <div
            class="item"
            :class="`col-${computedMode}-${modeAwareFlexBreak}`"
            v-for="(item, index) in acf.items"
          >
            <div class="content">
              <div class="content-body">
                <figure v-if="item.image" class="mb-4">
                  <img
                    class="img-fluid"
                    v-bind:src="item.image.sizes.large"
                    alt=""
                  />
                </figure>
                <h5 v-html="item.title"></h5>
                <p v-if="item.description" v-html="item.description"></p>
              </div>

              <div class="call-to-action">
                <a
                  v-if="acf.layout['cta-style'] === 'pill'"
                  v-bind:href="item.cta.href"
                  v-bind:target="item.cta.target"
                  class="btn cta-pill filled-red icon right-arrow"
                  >{{ item.cta.text }}</a
                >
                <a
                  v-if="acf.layout['cta-style'] === 'text'"
                  v-bind:href="item.cta.href"
                  v-bind:target="item.cta.target"
                  class="btn cta-plain text-red icon right-arrow"
                  >{{ item.cta.text }}</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "component-de94ab88", // explore_4col-line_text_link
  props: ["acf"],
  computed: {
    computedMode() {
      return (
        {
          xs: "sm",
          sm: "sm",
          md: "md",
          lg: "lg",
          xl: "xl",
        }[this.$root.mode] || "md"
      );
    },
    modeAwareFlexBreak() {
      return (
        {
          xs: 12,
          sm: 6,
          md: 4,
          lg: 3,
          xl: 3,
        }[this.$root.mode] || 3
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.component-de94ab88 {
  // -->
}

.component {
  padding: 3rem 0 5rem 0;

  .content {
    height: 100%;
    display: flex;
    flex-direction: column;

    .content-body {
      padding-bottom: 1rem;
      margin-bottom: auto;
    }
  }

  .container {
    margin-left: -10px;
    margin-right: -10px;
  }

  h2 {
    position: relative;
    margin-bottom: 2rem;

    @extend %eyebrow-left;
  }

  h5 {
    margin-bottom: 0.725rem;
  }

  &.is-cta-style-pill {
    .item {
      @media (min-width: 992px) {
        padding-bottom: 3.5rem;
      }
    }
  }

  &.content-alignment-center {
    h2,
    h5 {
      text-align: center;
    }

    h2 {
      @extend %eyebrow-center;
    }

    .item {
      text-align: center;
    }
    .content {
      @media (min-width: 992px) {
        padding: 0 1.75rem;
      }
    }
  }

  .item {
    margin-bottom: 3rem;

    @media (min-width: 992px) {
      padding-bottom: 1rem;
    }

    figure {
      overflow: hidden;
      border-radius: 6px;
      box-shadow: -1px 0.25rem 12px 2px rgba(0, 0, 0, 0.125);
    }
  }

  .call-to-action {
    .cta-plain {
      left: auto;
    }
  }
}
</style>